module.exports = __webpack_public_path__ + "img/network.2a8b5413.png";